import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsFloatBtns.vue?vue&type=template&id=6b7b75e1&"
import script from "./MonthAllowancesPlanDetailsFloatBtns.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports